/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RecommendationInputs */

const cs_enum_recommendation = /** @type {(inputs: Enum_RecommendationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doporučení`)
};

const en_enum_recommendation = /** @type {(inputs: Enum_RecommendationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referral`)
};

/**
* | output |
* | --- |
* | "Referral" |
*
* @param {Enum_RecommendationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_recommendation = /** @type {((inputs?: Enum_RecommendationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RecommendationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_recommendation(inputs)
	return cs_enum_recommendation(inputs)
});